'use client'

import { useEffect, useState } from 'react'
import Modal from '@/components/widgets/Modal'
import 'react-phone-number-input/style.css'
import Image from 'next/image'

export default function InitialPopUp({isModalOpen,setIsModalOpen,startAnimation,setStartAnimation,handleSubmit,handleClose}:any) {
  const [value, setValue] = useState<any>()
  const [checkBox, setCheckBox] = useState<any>()

  if (!isModalOpen) return <div />

  return (
    <Modal isOpen={isModalOpen} onClose={handleClose}>
      <div
        className={`bg-white max-w-[732px] min-h-[431px] sm:flex block rounded-lg border-none overflow-hidden transition-all duration-500 ${
          startAnimation ? 'translate-x-0' : 'translate-x-full'
        } `}
      >
        <button
          onClick={handleClose}
          className='pb-[2px] pl-[1px] absolute top-4 right-4 text-black bg-[#fff] text-[16px] rounded-full h-[24px] w-[24px] flex justify-center items-center'
        >
          ×
        </button>
        <div className='sm:w-[307px] w-full h-[227px] sm:h-full bg-gray-300 block'>
          <img
            src='https://vert-test-assets.nyc3.cdn.digitaloceanspaces.com/website/Home_Page/welcome_banner.png'
            alt='homepage banner'
            width={307}
            height={482}
            className='sm:h-full h-[227px] w-full object-cover'
          />
        </div>
        <div className='sm:w-[425px] w-full bg-black text-white sm:pl-6 pl-3 p-6'>
          <p className='text-xs uppercase tracking-wide text-white font-barlow text-[12px]'>
            Sparkle This Holiday
          </p>
          <h2 className='font-cambonLight sm:text-[24px] leading-[30px] text-[24px] mt-2'>
            Enjoy a <i className='font-cambonLightItalic'>flat 15% off</i> on{' '}
            <br />
            Your First Purchase
          </h2>
          <p className='font-barlowLight sm:text-[16px] leading-[20px] text-[14px] text-white mt-2'>
            Sign up now to receive your exclusive discount code in your inbox
            and checkout.
          </p>
          <div className='mt-[14px] space-y-4'>
            <div className='h-[48px] border border-white bg-white rounded-md flex items-center px-4'>
              <input
                type='email'
                className='w-full outline-none text-sm text-[#000] placeholder-gray-400'
                value={value}
                onClick={(e:any)=>setValue(e?.target?.value)}
              />
            </div>

            <div className='text-[14px] font-barlowExtraLight text-[#fff] my-[13px]'>
              I’m interested in:
            </div>

            {[
              'ENGAGEMENT RINGS',
              'WEDDING, ANNIVERSARY & ETERNITY RINGS',
              'ESSENTIAL JEWELRY',
            ].map((label, index) => {
              return (
                <label
                  key={index}
                  className='flex items-center space-x-2 !my-[10px] cursor-pointer text-white'
                >
                  <input
                    type='checkbox'
                    id={`checkbox-${index}`}
                    className='hidden peer'
                    onClick={(e: any) => setCheckBox(index + 1)}
                  />
                  <div className='w-5 h-5 border border-white flex items-center justify-center'>
                    {checkBox === index + 1 && (
                      <span className='text-white font-semibold'>✓</span>
                    )}
                  </div>
                  <span className='text-[#fff] text-[14px] font-barlowNormal'>
                    {label}
                  </span>
                </label>
              )
            })}

            <button
              type='submit'
              className='h-[42px] rounded-full px-[13px] py-[20px] border border-solid border-[#fff] flex justify-center items-center text-[16px] font-barlowMedium'
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
          <p className='text-[10px] font-barlowExtraLight text-white mt-[6px]'>
            By opting in to receive texts, you consent to receive marketing text
            messages from Vertelier. Consent is not a condition of purchase,
            message and data rates may apply, opt out at any time by replying
            STOP. View{' '}
            <a href='#' className=''>
              Terms & Privacy
            </a>
            .
          </p>
        </div>
      </div>
    </Modal>
  )
}
